// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Raw_wrapper__Fw9ZE","value":"Raw_value__oNElL"};